export const getCMMCLinkType = (uid: string, linkType: string, locale: string | undefined) => {
  switch (locale) {
    case 'en-us':
      return `/hub/${linkType}/${uid}`
    case 'de-de':
      return `/de-de/hub/${linkType}/${uid}`
    case 'es-es':
      return `/es-es/hub/${linkType}/${uid}`
    case 'fr-fr':
      return `/fr-fr/hub/${linkType}/${uid}`
    default:
      return `/hub/${linkType}/${uid}`
  }
}
